import { types } from "../types/types";

const initialState = {
    textosLegales: null,
}

export const textLegalReducer = ( state = initialState, action ) => {
    switch (action.type) {

        case types.textLegalLoad:
            return {
                ...state,
                textosLegales: action.payload
            }

        default:
            return state;
    }
}

